import styled from 'styled-components';

export const TimeSeriesGridWrapper = styled.div`
    height: 400px;
`;
